/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import PropTypes from 'prop-types';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { useInput, InputProps } from 'ra-core';
import { useTranslate } from 'react-admin';

const getMonthString = (value: Date | string | null | undefined) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export type MonthYearRangeInputProps = InputProps<TextFieldProps> &
  Omit<TextFieldProps, 'helperText' | 'label'> & {
    label?: string;
  };

const MonthYearRangeInput = ({
  source,
  label,
  margin = 'dense',
  variant = 'filled',
  ...rest
}: MonthYearRangeInputProps) => {
  const today = new Date();
  const { input } = useInput({
    source,
    defaultValue: `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, '0')}`,
  });
  const t = useTranslate();
  const value = getMonthString(input.value);
  const year = value ? parseInt(value.slice(0, 4)) : today.getFullYear();
  const month = value ? parseInt(value.slice(5, 7)) : today.getMonth() + 1;
  const years = Array.from(
    { length: 21 },
    (_, i) => today.getFullYear() - 10 + i
  );
  const inputLabelProps = { shrink: true };
  const months = t('month.list').split('|');

  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 5 }}>
      <TextField
        select
        label={t('fields.date.month')}
        value={month}
        onChange={(e) => {
          const selectedMonth = String(e.target.value).padStart(2, '0');
          input.onChange(`${year}-${selectedMonth}`);
        }}
        SelectProps={{ native: true }}
        variant={variant}
        margin={margin}
        {...rest}
      >
        {months.map((m: string, i: number) => (
          <option key={m} value={i + 1}>
            {m}
          </option>
        ))}
      </TextField>

      <TextField
        select
        label={t('fields.date.year')}
        value={year}
        onChange={(e) =>
          input.onChange(`${e.target.value}-${String(month).padStart(2, '0')}`)
        }
        SelectProps={{ native: true }}
        variant={variant}
        margin={margin}
        InputLabelProps={inputLabelProps}
        {...rest}
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </TextField>
    </div>
  );
};

MonthYearRangeInput.propTypes = {
  source: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default MonthYearRangeInput;
